<template>
    <div>
        <div v-for="(piece, index) in pieces" :key="index">
            <div class="mb-1 flex items-center">
                <span class="mr-3 w-24 text-center">{{ __('Peça :n', { n: index + 1 }) }}</span>
                <span class="font-bold mr-1">X</span>
                <input class="input w-24" v-model="piece.x" />

                <span class="ml-4 mr-1 font-bold">Y</span>
                <input class="input w-24" v-model="piece.y" />
            </div>
        </div>

        <button
            type="button"
            class="p-1 text-sm px-3 flex items-center space-x-1 rounded-full bg-gray-100 hover:bg-gray-200"
            @click="add()"
        >
            <span>{{ __('Incluir peça') }}</span>
        </button>
    </div>
</template>

<script>
export default {
    props: ['value', 'field'],
    data() {
        return {
            pieces: [{ x: '', y: '' }],
        }
    },
    watch: {
        pieces: {
            deep: true,
            handler(value) {
                this.$emit('input', value)
            },
        },
    },
    methods: {
        add() {
            this.pieces.push({ x: '', y: '' })
        },
    },
}
</script>